.yh39js0 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.yh39js1 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
}
.yh39js2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background-color: var(--_1qu8za2b);
  border-radius: 12px;
  border: 1px solid var(--_1qu8za21);
}
.yh39js3 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.yh39js4 {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
}
.yh39js5 {
  font-weight: 500;
  font-size: 45px;
  line-height: 1.35;
  letter-spacing: 0.01em;
  color: var(--_1qu8za23);
}
.yh39js6 {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
}
.yh39js7 {
  font-weight: 700;
  font-size: 22px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: var(--_1qu8za23);
  margin-bottom: 12px;
}
.yh39js8 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.yh39js9 {
  padding: 16px;
  background-color: var(--_1qu8za2b);
  border-radius: 12px;
  border: 1px solid var(--_1qu8za21);
  container-type: inline-size;
}
.yh39jsa {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-direction: column;
}
.yh39jsb {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.yh39jsc {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: var(--_1qu8za23);
}
.yh39jsd {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
}
.yh39jse {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
}
.yh39jsf {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  flex-shrink: 0;
  color: var(--_1qu8za27);
}
.yh39jsg {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.yh39jsh {
  container-type: inline-size;
  background-color: var(--_1qu8za2b);
  border-radius: 12px;
  border: 1px solid var(--_1qu8za21);
}
.yh39jsi {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}
.yh39jsj {
  position: relative;
  width: 100%;
  flex: 0 0 clamp(200px, 10cqw + 200px, 280px);
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}
.yh39jsk {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.yh39jsl {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  transition: background 0.15s ease;
}
.yh39jsj:hover .yh39jsl {
  background: rgba(0, 0, 0, 0.5);
}
.yh39jsm {
  width: 48px;
  height: 48px;
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}
.yh39jsn {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
}
.yh39jso {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.yh39jsp {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: var(--_1qu8za23);
}
.yh39jsq {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
}
.yh39jsr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.yh39jss {
  max-width: 920px;
}
.yh39jst {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  outline: none;
}
.yh39jsu {
  display: flex;
  justify-content: center;
  padding: 48px;
}
@container (min-width: 500px) {
  .yh39jsa {
    flex-direction: row;
    align-items: center;
  }
  .yh39jsi {
    flex-direction: row;
  }
}